import React from 'react'
import { createPortal } from 'react-dom'

const FullscreenOverlay = ({ imageSrc, isOpen, onClose }) => {
  if (!isOpen || !imageSrc) return null

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose()
    }
  }

  return createPortal(
    <div className="image-fullscreen-overlay" onClick={handleOverlayClick}>
      <img 
        src={imageSrc} 
        alt="Fullscreen" 
        className="image-fullscreen"
      />
      <button 
        className="overlay-close" 
        aria-label="Close" 
        onClick={onClose}
      >
        <i className="fas fa-compress"></i>
      </button>
    </div>,
    document.body
  )
}

export default FullscreenOverlay